import React from 'react';
import S from './ProgressBar.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ProgressBar(props) {
  const {
    loading,
    progress = 100
  } = props;
  const position = 100 - progress;
  return /*#__PURE__*/_jsx("div", {
    hidden: !loading,
    className: S.progressBar,
    children: /*#__PURE__*/_jsx("div", {
      className: S.progressThumb,
      style: {
        right: `${position}%`
      }
    })
  });
}